import { useEffect } from 'react';
import { useHTTP } from 'hooks/useRequest';
import { requestTypes, groupActions } from './approvals_group_reducer';

const useInititalLoadRequest = (
  editMode,
  initialLoadUrl,
  editGroupUrl,
  request,
  approvalGroupDispatch,
) => {
  const initialLoadRequest =
    request.status && request.type === requestTypes.INITIAL_LOAD;

  const requestUrl = editMode ? editGroupUrl : initialLoadUrl;

  const requestConfig = {
    method: 'get',
    url: initialLoadRequest ? requestUrl : null,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  };

  const { data } = useHTTP(requestConfig);

  useEffect(() => {
    if (!data) return;

    const {
      description: {
        validation_rules: { max_length: descriptionMaxLength },
      },
      name: {
        validation_rules: { max_length: nameMaxLength },
      },
    } = data.approval_group;

    const [
      { administrator: adminsCount = 0 } = {},
      { standard: usersCount = 0 } = {},
      { approver: approversCount = 0 } = {},
    ] = data.account_user_count;

    approvalGroupDispatch({
      type: groupActions.INITIAL_LOAD_REQUEST,
      payload: {
        nameMaxLength,
        descriptionMaxLength,
        adminsCount,
        approversCount,
        usersCount,
      },
    });

    approvalGroupDispatch({
      type: groupActions.DISABLE_REQUEST,
    });

    if (!editMode) {
      // This url is only provided on create group request
      approvalGroupDispatch({
        type: groupActions.UPDATE_CREATE_GROUP_URL,
        payload: data.approval_group.routes.create_url,
      });
    }

    if (editMode) {
      // Add group details and users from request

      const {
        name,
        description,
        can_delete: canDelete,
        status,
        messaging = { title: '', body: '' },
        routes,
      } = data.approval_group;

      approvalGroupDispatch({
        type: groupActions.NAME_INPUT,
        payload: name.value ? name.value : '',
      });

      approvalGroupDispatch({
        type: groupActions.INITITAL_GROUP_NAME,
        payload: name.value ? name.value : '',
      });

      approvalGroupDispatch({
        type: groupActions.DESCRIPTION_INPUT,
        payload: description.value ? description.value : '',
      });

      approvalGroupDispatch({
        type: groupActions.UPDATE_GROUP_STATUS,
        payload: { status, messaging, canDelete },
      });
      approvalGroupDispatch({
        type: groupActions.UPDATE_GROUP_STATUS_URL,
        payload: routes,
      });

      const { administrator, approver, standard } = data.approval_group_users;

      approvalGroupDispatch({
        type: groupActions.UPDATE_ALL_ADMINS,
        payload: administrator,
      });

      approvalGroupDispatch({
        type: groupActions.UPDATE_ALL_APPROVERS,
        payload: approver,
      });

      approvalGroupDispatch({
        type: groupActions.UPDATE_ALL_USERS,
        payload: standard,
      });
    }
  }, [data]);
};

export default useInititalLoadRequest;
